export interface File {
    id: number;
    fetch?: boolean;
    name?: string; // with ext
    fullPath: string;
    thumb?: string;
    ext?: string;
    realName?: string;
    questionId?: number;
    width?: number;
    height?: number;
    link?: string;
}

export const initialFile: Readonly<File> = {
    fetch: false,
    id: 0,
    name: '',
    fullPath: '',
    thumb: '',
    ext: '',
    questionId: null,
    width: 0,
    height: 0,
    link: '',
};
